<template>
  <div>
    <div class="refund-style">
      <div class="refund-style-padding">
          <template v-if="salesLeader">
          <div class="order-amounts">
            <div><span>退款提交时间</span><span>{{postModel.refundModel.SUBMIT_TIME}}</span></div>
            <div><span>终端用户负责人</span><span>{{postModel.refundModel.CREATOR}}</span></div>
            <div>
              <span v-if="postModel.refundModel.FIVE_AUDIT_STATUS == 1 || postModel.refundModel.STATE_NAME == '用户确认退款申请中'">流程节点</span>
              <span v-else>审核状态</span>
              <i
                :class="{
                  'audit-status': true,
                  'under-review': postModel.refundModel.STATE_NAME.indexOf('中')>-1,
                  'reject-review': postModel.refundModel.STATE_NAME.indexOf('驳回')>-1,
                  'finish-review': postModel.refundModel.STATE_NAME.indexOf('通过')>-1,
                }"
                >{{postModel.refundModel.CONFIRM_REFUND_STATE==2?'退款成功':postModel.refundModel.STATE_NAME}}</i>
            </div>
            <div><span>审核明细</span><i class="audit-details" @click="viewDetail">查看</i></div>
            <div v-if="postModel.refundModel.STATE == 8">
              <span>驳回理由</span><span class="reject-reason">{{postModel.refundModel.REFUND_REJECT_REASON}}</span>
            </div>
          </div>
          <div class="order-main">
            <p class="order-title">订单信息</p>
            <div class="order-cont">
              <div><span>订单类型</span>{{postModel.reconcileVo.CUSTOMER_ORDER_TYPE}}</div>
              <div><span>受检者姓名</span>{{postModel.reconcileVo.NAME}}</div>
              <div><span>终端受检者编号</span>{{postModel.reconcileVo.CLIENT_ID}}</div>
              <div><span>付款金额</span>￥ {{this.abs(postModel.reconcileVo.PAYMENT_MONEY_AMOUNT)}}</div>
              <div><span>已对账金额</span>￥ {{this.abs(postModel.reconcileVo.PAY_AMOUNT)}}</div>
              <div><span>发票状态</span>{{postModel.reconcileVo.IS_INVOICE==1?'已开票':(postModel.reconcileVo.IS_INVOICE==0?'未开票':'')}}</div>
            </div>
          </div>
        </template>
        <template v-if="nosalesLeader" >
          <div :class="{ 'order-amounts': true, 'order-bottom': postModel.refundModel.STATE !== 1 }">
          <div :class="{ 'not-submitted': postModel.refundModel.STATE === 1 }">
            <span>订单金额</span><span>￥ {{this.abs(postModel.reconcileVo.PAY_AMOUNT)}}</span>
          </div>
          <template v-if="postModel.refundModel.STATE == 2 || postModel.refundModel.STATE == 4 || postModel.refundModel.STATE == 8">
            <div><span>提交时间</span><span>{{postModel.refundModel.SUBMIT_TIME}}</span></div>
            <div>
              <span v-if="postModel.refundModel.FIVE_AUDIT_STATUS == 1 || postModel.refundModel.STATE_NAME == '用户确认退款申请中'">流程节点</span>
              <span v-else>审核状态</span>
              <i
                :class="{
                  'audit-status': true,
                  'under-review': postModel.refundModel.STATE_NAME.indexOf('中')>-1,
                  'reject-review': postModel.refundModel.STATE_NAME.indexOf('驳回')>-1,
                  'finish-review': postModel.refundModel.STATE_NAME.indexOf('通过')>-1,
                }"
                >{{postModel.refundModel.CONFIRM_REFUND_STATE==2?'退款成功':postModel.refundModel.STATE_NAME}}</i>
            </div>
            <div><span>审核明细</span><i class="audit-details" @click="viewDetail">查看</i></div>
            <div v-if="postModel.refundModel.STATE == 8">
              <span>驳回理由</span><span class="reject-reason">{{postModel.refundModel.REFUND_REJECT_REASON}}</span>
            </div>
          </template>
        </div>
        </template>
        <div class="order-main">
          <p class="order-title">退款信息</p>
          <refundInfo :refundInfo="postModel" />
        </div>
      <div v-if="postModel.refundModel.REFUND_PROCESS_NAME=='线下退款(销售上传申请附件)'">
        <div class="refund-appendix" v-if="isApply">
          <p class="info-title">退款申请附件</p>
          <p class="info-bot"></p>
          <div class="appendix-style">
            <div>
              <span v-if="isEdit==true" class="title-label">退款申请<i>*</i></span>
              <span v-else class="title-label" style="color: #9095a7">退款申请</span>
              <div class="info-input info-input-new info-input-upload">
                <div class="upload-list">
                  <div
                    v-for="(item, index) in postModel.salePath"
                    :key="'img_' + index"
                    class="imgArrClass"
                  >
                    <van-image :src="item.url" @click="seeBigImage(item.url)"/>
                    <i v-if="isEdit==true"
                      class="deleteImgStyle"
                      style="top: 0"
                      @click="deleteImg(item)"
                    >X</i>
                  </div>
                  <div class="upload-btn" v-if="isHandle == true && postModel.refundModel.FIVE_AUDIT_STATUS == 1" @click="afterReadFun(8)">
                    <span class="iconfont icon-shangchuantupian"></span>
                    <span>上传附件</span>
                  </div>
                  <div class="imgArrClass">
                    <van-image @click="seeRefundImage" :src="require('../../../assets/refundImg.png')" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--        <div :class="{ 'info-btns': true, 'info-btns-edit': postModel.refundModel.STATE == 1 || postModel.refundModel.STATE == 8 || postModel.refundModel.FIVE_AUDIT_STATUS == 1}">-->
<!--          <template v-if="postModel.refundModel.STATE == 1 || postModel.refundModel.STATE == 8">-->
<!--            <van-button round block type="default" @click="editDetail">编辑1</van-button>-->
<!--          </template>-->
<!--          <template v-else-if="isHandle">-->
<!--            <van-button v-if="postModel.refundModel.FIVE_AUDIT_STATUS == 1" round block type="default" @click="finishApproval('同意')">提交1</van-button>-->
<!--            <template v-else>-->
<!--              <van-button round block type="default" class="approval-not-btn" @click="approvalRejectedFun('不同意')">审批驳回1</van-button>-->
<!--              <van-button round block type="info" class="approval-submit-btn" @click="approvalRejectedFun('同意')">审批通过1</van-button>-->
<!--            </template>-->
<!--          </template>-->
<!--          <template v-else-if="postModel.refundModel.STATE == 4">-->
<!--            <van-button round block type="default" class="save-btn">保存1</van-button>-->
<!--            <van-button round block type="info" class="submit-btn">提交1</van-button>-->
<!--          </template>-->
<!--        </div>-->
      </div>
    </div>
    <van-popup v-model="approvalOpinions" position="bottom" closeable round>
      <div class="approval-opinions">
        <p>审批意见</p>
        <van-field
          v-model="approvalText"
          rows="3"
          autosize
          type="textarea"
          placeholder="请输入审批意见"
          show-word-limit
        />
        <div class="btns">
          <van-button round block type="default" @click="closeApproval"
            >取消</van-button
          >
          <van-button round block type="info" @click="finishApproval"
            >确认</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import refundInfo from "./compontents/refund-info";
import { sendRequest } from "../../../api/order";
import { Toast , Dialog } from "vant";
import isiOS from "../../../utils/iosAn";

export default {
  name: "refundEdit",
  data() {
    return {
      orderCode:'',
      parameterId:'',
      postModel: {
        reconcileVo: {
          PAY_AMOUNT: "",
        },
        refundModel: {
          REFUND_PROCESS: "",
          PAY_TYPE: "",
        },
        deathFilePath: [],
        relationshipFilePath: [],
        refundContractPath: [],
        salePath: [],
      },
      pageType: null, //1 未提交   2 已提交  3退款审批   4 退款传附件
      isEdit: true,
      isApply: false,
      isP: "",
      isHandle: false,
      salesLeader: false,
      nosalesLeader: false,
      approvalOpinions: false, //审批意见
      approvalText: "",
      approvalType: "",
      statusP: "", //判断app是从待办的已完成进入还是未完成进入
    };
  },
  watch: { // watch 监听 props 中的值
    postModel(newVal, oldVal) { // newVal 为新值， oldVal 为旧值
      console.log("newVal", newVal);
      this.postModel = newVal;
    }
  },
  components: {
    refundInfo,
  },
  created() {
    var result = this.getUrlParams(location.href);
    console.log(result);
    this.orderCode = result.orderCode;
    this.parameterId = result.parameterId;
    this.statusP = result.status != undefined?result.status:'';
  },
  mounted() {
    if (this.parameterId == '1-1'){ //查看详情进入
      this.getOrderDetail();
    }else { //首页待办进入
      this.getRefundView();
    }

    //拿app 的返回值
    window.NativeCallJS = (res) => {
      var _data = JSON.parse(res);
      console.log(_data)
      if (_data.type == 8) {
        this.afterRead(_data);
      } else if(_data.buttonType == 1){ //提交
        this.finishApproval("同意",_data.buttonType);
      } else if(_data.buttonType == 2){ // 审批不同意
        this.finishApproval("不同意",_data.remark)
      } else if(_data.buttonType == 3){ // 删除退款申请
        this.deleteRefund()
      } else if(_data.buttonType == 4){ // 审批同意
        // this.finishApproval("同意",_data.buttonType);_data.remark
         this.finishApproval("同意",_data.remark);
      }
    };
  },
  methods: {
      // 金额 格式化
      abs(value) {  
      if (!value && value !== 0) return '-';
      var intPart = Number(value) | 0; //获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{})+$)/g, '$1,'); //将整数部分逢三一断
  
      var floatPart = ".00"; //预定义小数部分
      var value2Array = value.toString().split(".");
  
      //=2表示数据有小数位
      if (value2Array.length == 2) {
          floatPart = value2Array[1].toString(); //拿到小数部分
  
          if (floatPart.length == 1) { //补0,实际上用不着
              return intPartFormat + "." + floatPart + '0';
          } else {
              return intPartFormat + "." + floatPart;
          }
      } else {
          return intPartFormat + floatPart;
      }
    },
    seeRefundImage(){
      console.log('https://obs.genetroncare.com/group1/M00/04/D2/CmQihGMpTYiAHE9aAAM3hCTnAaQ544.jpg')
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          refundImg: 'https://obs.genetroncare.com/group1/M00/04/D2/CmQihGMpTYiAHE9aAAM3hCTnAaQ544.jpg',
        });
      } else {
        window.android.JSCallNative(JSON.stringify({ refundImg: 'https://obs.genetroncare.com/group1/M00/04/D2/CmQihGMpTYiAHE9aAAM3hCTnAaQ544.jpg' }));
      }
    },
    seeBigImage(image){
      let imgUrl=image.split('?')[0]
      console.log(imgUrl)
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          image: imgUrl,
        });
      } else {
        window.android.JSCallNative(JSON.stringify({ image: imgUrl }));
      }
    },
    // 取url参数
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    //上传
    afterReadFun(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          type: type,
        });
      } else {
        window.android.JSCallNative(JSON.stringify({ type: type }));
      }
    },

    async afterRead(listArr) {
      let _data = {
        requestType: "POST",
        url: "/BuLimsSamplingList/samplingFileCon",
        params: {},
        isBody: true,
        body: {
          samplingId: this.postModel.refundModel.ID,
          flag: listArr.type,
          userCode: listArr.code,
          userName: listArr.name,
          baseFileInfo: listArr.list,
        },
      };
      console.log(222222);
      // eslint-disable-next-line no-unused-vars
      let { data, code } = await sendRequest(_data);
      if (code === 20000) {
        this.getSelectFilePath();
      }
    },
    //删除附件
    async deleteImg(file) {
      let _data = {
        requestType: "GET",
        url: "/limsOrderTable/deleteFile",
        params: { fileId: file.ID },
        isBody: false,
        body: {},
      };
      let { data, code } = await sendRequest(_data);
      if (code === 20000) {
        this.getSelectFilePath();
      }
    },
    //统一调用的接口方法
    async getSendRequest(_data) {
      let { data } = await sendRequest({
        requestType: _data.type, //接口 是 get 还是post
        url: _data.url, //接口地址
        params: _data.paramsData, //get 接口的参数
        isBody: _data.isBody, // 必填get传false ,post传true
        body: _data.bodyData, //post 接口的参数
      });
      return data;
    },
    //身份查询
    async getAuditBefore() {
      let _data = {
        requestType: "POST",
        url: "/refund/auditBefore",
        params: {},
        isBody: true,
        body: {
          ID:this.postModel.refundModel.ID
        },
      };
      let { data, code } = await sendRequest(_data);
      if(code === 20000){
        console.log(data)
        // isP  查角色
        this.isP = data;
        if(this.postModel.refundModel.FIVE_AUDIT_STATUS == 2){
          // this.isApply = true; //可以显示退款证明
          this.isEdit = false; //不能编辑退款证明
          this.nosalesLeader = true; 
          if (this.postModel.salePath.length!=0) {
            this.isApply = true
          }else{
            this.isApply = false
          }
        }
        if(this.isP == null){ //销售
        this.nosalesLeader = true; 
          if(this.postModel.refundModel.FIVE_AUDIT_STATUS == 1){
            this.isHandle = true; // 可以办理
            this.isApply = true; //可以显示退款证明
            this.isEdit = true; //可以编辑退款证明
          }
        }else if(this.isP == "THIRDLY_AUDIT_SHENWAI" || this.isP == "THIRDLY_AUDIT_ZHONGLIU" || this.isP == "THIRDLY_AUDIT_ZHANLUE" || this.isP == "THIRDLY_AUDIT_QUDAO"){
          this.isEdit = false; //不能编辑退款证明
          this.salesLeader = true; //销售领导
          this.nosalesLeader =false
          if(this.postModel.refundModel.THIRDLY_AUDIT_STATUS == 1){
            this.isHandle = true
            this.salesLeader = true; 
          }
        }else if(this.isP == "FOURTH_AUDIT"){
          this.isEdit = false; //不能编辑退款证明
          this.salesLeader = true; 
          this.isDis = true;
          if (this.postModel.salePath.length!=0) {
            this.isApply = true
          }else{
            this.isApply = false
          }
          if(this.postModel.refundModel.FOUR_AUDIT_STATUS == 1){
            this.isHandle = true
            // this.isApply = false
            this.nosalesLeader = false; 
          } else{
            // this.isApply = true
            this.nosalesLeader = false; 
          }
        }
      }
      //传参给APP 展示按钮
      let type = 0;
      if(parseInt(this.statusP) == 0){ //待办已完成进入
        type = 0; //不展示按钮
      }else {
        if(this.postModel.refundModel.STATE == 1 || this.postModel.refundModel.STATE == 8){
          type = 1;//显示 编辑
        } else if(this.isHandle == true){
          if (this.postModel.refundModel.FIVE_AUDIT_STATUS == 1){
            type = 2; //显示 提交
          } else {
            type = 3; //显示 审批驳回/审批通过
          }
        } else if(this.postModel.refundModel.STATE == 4){
          type = 4; //显示 保存/提交
        }
      }
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({type: type});
      } else {
        window.android.JSCallNative(JSON.stringify({type: type}));
      }
    },
    //从订单详情进入调用接口
    getOrderDetail() {
      let _data = {
        type: "GET",
        url: "/refund/appSave",
        paramsData: { orderCode: this.orderCode },
        isBody: false,
        bodyData: {},
      };
      this.voDetailData(_data);
    },
    //页面刷新接口(从待办跳转进入)
    getRefundView() {
      let _data = {
        type: "get",
        url: "/refund/view",
        paramsData: { ID: this.parameterId },
        isBody: false,
        bodyData: {},
      };
      this.voDetailData(_data);
    },
    //接口返回值更新
    async voDetailData(_data) {
      this.postModel = await this.getSendRequest(_data);
      if (this.postModel.refundModel.REFUND_PROCESS == 1) {
        this.postModel.refundModel.REFUND_PROCESS_NAME = "小程序(用户确认申请)";
      } else if (this.postModel.refundModel.REFUND_PROCESS == 2) {
        this.postModel.refundModel.REFUND_PROCESS_NAME = "线下退款(销售上传申请附件)";
      }
      if(this.postModel.refundModel.STATE_NAME == null){
        this.postModel.refundModel.STATE_NAME = "";
      }
      this.postModel.deathFilePath = [];
      this.postModel.relationshipFilePath = [];
      this.postModel.refundContractPath = [];
      this.postModel.salePath = [];
      //获取上传的文件路径
      this.getSelectFilePath();
      //查询身份
      this.getAuditBefore();
      // 驳回状态编辑改修改
      if (this.postModel.refundModel.STATE_NAME=='审批驳回') {
        if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage({
            reject:1,
          });
        } else {
          window.android.JSCallNative(JSON.stringify({ reject: 1 }));
        }
      }
    },
    //附件列表
    async getSelectFilePath() {
      let _data = {
        type: "GET",
        url: "/refund/selectFilePath",
        paramsData: { orderId: this.postModel.refundModel.ID },
        isBody: false,
        bodyData: {},
      };
      let fileArr = await this.getSendRequest(_data);
      fileArr.deathFilePath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      fileArr.relationshipFilePath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
       fileArr.refundContractPath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      fileArr.salePath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      this.$set(this.postModel, "deathFilePath", fileArr.deathFilePath);
      this.$set(this.postModel, "relationshipFilePath", fileArr.relationshipFilePath);
      this.$set(this.postModel, "refundContractPath", fileArr.refundContractPath);
      this.$set(this.postModel, "salePath", fileArr.salePath);

    },
    //编辑
    editDetail(){
      this.$router.replace({
        path: "/order/refundDetails",
        query:{
          orderCode:this.orderCode
        }
      });
    },
    //审批驳回
    approvalRejectedFun(val) {
      this.approvalOpinions = true;
      this.approvalText = "";
      this.approvalType = val;
    },
    closeApproval() {
      this.approvalOpinions = false;
      this.approvalText = "";
    },
    async finishApproval(type,text) {
      let _data = {
        requestType: "POST",
        url: "/refund/audit?id=" + this.postModel.refundModel.ID,
        params: {},
        isBody: true,
        body: {
          AUDIT_RESULT: type,
          AUDIT_OPINION: text==1 || text == 4?'':text,
        },
      };
      console.log('text',text);
      if(text == 1){ //提交未上传附件提示
        if(this.postModel.salePath ==null || this.postModel.salePath.length == 0) {
          Toast("请先上传退款申请附件再提交");
          return;
        }
      }
      // eslint-disable-next-line no-unused-vars
      let { data, code } = await sendRequest(_data);
      if (code === 20000) {
        Toast("操作成功");
        if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage({
            message:'success',
          });
        } else {
          window.android.JSCallNative(JSON.stringify({ message: 'success' }));
        }
      }else{
        Toast("操作失败");
      }
    },
    //删除退款
    async deleteRefund(){
      let _data = {
        requestType: "GET",
        url: "/refund/deleteRefund",
        params: { id: this.postModel.refundModel.ID},
        isBody: true,
        body: {},
      };
      let { data, code } = await sendRequest(_data);
      if(code === 20000){
        Toast("删除成功");
        if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage({
            message:'delete',
          });
        } else {
          window.android.JSCallNative(JSON.stringify({ message: 'delete' }));
        }
      }
    },
    //查看退款审批明细
    viewDetail(){
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({message:'view',refundID:this.postModel.refundModel.ID,});
      } else {
        window.android.JSCallNative(JSON.stringify({message:'view',refundID:this.postModel.refundModel.ID,}));
      }
    }
  },
};
</script>

<style lang="less" scoped>
.header-bg {
  width: 100%;
  height: 128px;
  background: url("../../../assets/refundBg.png") no-repeat 100%;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
}
.refund-style {
  // font-family: PingFangSC-Medium, PingFang SC;
 /* background: rgb(255 255 255 / 0%);*/
  padding: 0 16px;
  margin-bottom: 120px;
  .refund-style-padding {
    position: relative;
  }
  .header-cont {
    h4 {
      line-height: 22px;
      font-size: 15px;
      font-weight: 500;
      color: #2f354d;

      .van-icon-arrow-left {
        width: 14px;
        height: 16px;
        margin-right: 14px;
      }
      .van-image {
        width: 18px;
        height: 18px;
        position: absolute;
        right: 0;
        top: 2px;
      }
    }
  }
  .order-amounts {
    background: #f4f8fd;
    border-radius: 10px;
    padding: 0 24px;
    margin: 20px 0;
    & > div {
      line-height: 40px;
      font-size: 15px;
      font-weight: 400;
      color: #2f354d;
      text-align: right;
      span:first-child {
        color: #9095a7;
        float: left;
      }
      i {
        font-style: normal;
      }
      .reject-reason {
        line-height: 26px;
        display: inline-block;
        width: 70%;
        margin-top: 7px;
      }
      .audit-status {
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        padding: 2px 8px;
      }
      .under-review {
        background: #efeaff;
        color: #7c67e6;
      }
      .reject-review {
        background: #ffecef;
        color: #ff627f;
      }
      .finish-review {
        background: #e5ffeb;
        color: #27ca8d;
      }
      .audit-details {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4b84ff;
      }
    }
    .not-submitted {
      height: 60px;
      line-height: 60px;
      span {
        height: 26px;
        font-size: 15px;
        font-weight: 400;
      }
      span:first-child {
        color: #9095a7;
      }
      span:last-child {
        color: #2f354d;
      }
    }
  }
  .order-bottom {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .order-main {
    height: 100%;
    background: #f4f8fd;
    border-radius: 10px;
    margin-bottom: 20px;
    .order-title {
      font-size: 15px;
      font-weight: 500;
     font-family: PingFangSC-Medium, PingFang SC;
      color: #2f354d;
      line-height: 22px;
      padding: 17px 0 13px;
      margin: 0 24px;
      border-bottom: 1px solid #e3e5e8;
    }
    .order-cont {
      padding: 0 24px 17px;
      margin-top: 10px;
      & > div {
        line-height: 32px;
        font-size: 13px;
        font-weight: 400;
        color: #2f354d;
        height: 32px;
        text-align: right;
        span {
          color: #9095a7;
          float: left;
        }
      }
      .upload-style {
        /*height: 128px;*/
        margin-bottom: 7px;
        .van-image {
          width: 90px;
          height: 90px;
          display: block;
        }
      }
    }
  }
  .refund-appendix {
    padding-bottom: 10px;
    background: #f4f8fd;
    border-radius: 10px;
    margin-top: 20px;
    .info-title {
      height: 70px;
      line-height: 70px;
      color: #2f354d;
      font-size: 18px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      padding: 0 24px;
    }
    .info-bot {
      height: 20px;
      background: linear-gradient(
        360deg,
        rgba(58, 74, 134, 0) 0%,
        rgba(58, 74, 134, 0.06) 100%
      );
    }
    .appendix-style {
      margin-top: 10px;
      padding: 0 24px;
      .title-label {
        font-size: 13px;
        color: #2f354d;
        i {
          color: #ff627f;
          font-style: normal;
          margin-left: 4px;
          position: relative;
          top: 2px;
        }
      }
    }
  }
  .info-btns {
    position: fixed;
    bottom: 140px;
    text-align: center;
    display: flex;
    .save-btn {
      border: none;
      font-size: 15px;
      font-weight: 400;
      color: #5f697d;
      letter-spacing: 1px;
      margin: 0 12px 0 8px;
      background: #ffffff;
      box-shadow: 0 6px 20px -2px rgba(52, 68, 132, 0.15);
      width: 100px;
    }
    button {
      border: none;
      background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
      box-shadow: 0 6px 20px -2px rgba(75, 132, 255, 0.3);
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 1px;
      width: 214px;
    }
    .approval-not-btn,
    .approval-submit-btn {
      width: 157px;
    }
    .approval-not-btn {
      background: #ffffff;
      box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.15);
      border-radius: 22px;
      margin-right: 13px;
      color: #5f697d;
      margin-left: 8px;
    }
  }
  .info-btns-edit {
    width: 214px;
    left: 50%;
    margin-left: -107px;
  }
}
.approval-opinions {
  padding: 20px 24px;
  p {
    height: 18px;
    font-size: 13px;
    font-weight: 500;
    color: #2f354d;
    line-height: 18px;
  }
  .van-cell {
    padding: 10px 0;
    font-size: 15px;
  }
  .btns {
    text-align: right;
    margin-top: 12px;
    button {
      display: inline-block;
      width: 76px;
      height: 30px;
      border-radius: 16px;
      font-size: 12px;
      font-weight: 400;
    }
    button:first-child {
      color: #4b84ff;
      margin-right: 12px;
      background: #ffffff;
      border: 1px solid #e3e5e8;
    }
    button:last-child {
      background: #4b84ff;
      color: #ffffff;
    }
  }
}
/deep/.van-overlay {
  background-color: #00000000;
}
/deep/.van-popup {
  box-shadow: 1px 0px 38px 20px #0000002b;
}
.upload-list {
  display: flow-root;
  /deep/.van-image,
  .upload-btn {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    overflow: hidden;
    background: #ffffff;
  }
  .upload-btn {
    margin: 5px 5px 0 0;
  }
  .upload-btn {
    text-align: center;
    color: #4b84ff;
    display: inline-block;
    span:first-child {
      width: 14px;
      height: 13px;
      display: block;
      margin: 27px auto 6px;
    }
    span:last-child {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
  .imgArrClass {
    width: 90px;
    height: 90px;
    position: relative;
    margin: 5px 5px 0 0;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;

    .deleteImgStyle {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0px 4px 0px 4px;
      color: #fff !important;
      font-size: 12px !important;
      display: inline-block;
      font-style: normal;
      text-align: center;
      line-height: 20px;
      position: absolute;
      right: 0;
    }
  }

  /deep/ .van-uploader__preview {
    margin: 5px 5px 0 0;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    .van-uploader__preview-image {
      width: 90px;
      height: 90px;
    }
    .van-uploader__preview-delete {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0px 4px 0px 4px;
      text-align: center;
      .van-uploader__preview-delete-icon {
        top: 1px;
        right: 1px;
        font-size: 18px;
      }
    }
  }
  /deep/ .van-uploader__input-wrapper {
    width: 90px;
    height: 90px;
    background: #ffffff;
    border-radius: 4px;
    text-align: center;
    color: #4b84ff;
    margin-top: 5px;
    span:first-child {
      width: 14px;
      height: 13px;
      display: block;
      margin: 27px auto 6px;
    }
    span:last-child {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
}

</style>
